import styled from 'styled-components'
export const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: stretch;
  justify-content: flex-end;
  z-index: 1050;
`

export const Panel = styled.div`
  background: ${({ theme }) => theme.app.background};
  color: ${({ theme }) => theme?.app?.text || '#fff'};
  width: ${({ width }) => width || '480px'};
  height: 100%;
  border-left: 1px solid
    ${({ theme }) => theme?.app?.inputBorder || 'rgba(255, 255, 255, 0.1)'};
  box-shadow: ${({ theme }) =>
    theme?.app?.boxShadow || '0 0 32px rgba(0, 0, 0, 0.35)'};
  display: flex;
  flex-direction: column;
  // padding-left: 16px;
  ${({ padding }) =>
    padding
      ? `padding: ${padding};`
      : `
  padding: 32px;
  padding-bottom: 5px;
  `}
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  // padding: 16px 20px 10px 20px;
`

export const Title = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: ${({ theme }) => theme?.app?.text || '#fff'};
`

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  color: ${({ theme }) => theme?.app?.text || '#fff'};
  cursor: pointer;
  font-size: 22px;
  line-height: 1;
  padding-right: 22px;
  z-index: 10;

  &:hover {
    opacity: 0.8;
  }
`

export const Content = styled.div`
  flex: 1;
  overflow-y: auto;
  // padding: 16px;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }
`
